export default __webpack_public_path__ + "static/media/skyticket.9fe04149.png";